import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { lecturesApi } from '../../api/lectures'
import Header from '../../components/layout/Header'
import Footer from '../../components/layout/Footer'
import Loading from '../../components/common/Loading'
import Card from '../../components/common/Card'
import './Notes.css'

const Notes = () => {
  const queryClient = useQueryClient()

  const { data, isLoading } = useQuery({
    queryKey: ['notes'],
    queryFn: () => lecturesApi.getNotes(),
  })

  const deleteMutation = useMutation({
    mutationFn: (id) => lecturesApi.deleteNote(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['notes'])
    },
  })

  if (isLoading) {
    return (
      <>
        <Header />
        <Loading fullScreen text="جاري التحميل..." />
        <Footer />
      </>
    )
  }

  const notes = data?.data?.notes || []

  return (
    <div className="notes-page bg-gray-900 min-h-screen">
      <Header />
      <main className="notes-main bg-gray-900">
        <div className="container mx-auto px-4">
          <h1 className="page-title text-white">ملاحظاتي</h1>
          <div className="notes-list">
            {notes.map((note) => (
              <Card key={note.id} className="note-card">
                <div className="note-header">
                  <h3 className="note-lecture">{note.lecture_title}</h3>
                  <button
                    className="note-delete"
                    onClick={() => deleteMutation.mutate(note.id)}
                  >
                    حذف
                  </button>
                </div>
                <p className="note-content">{note.content}</p>
                <span className="note-timestamp">
                  {new Date(note.created_at).toLocaleDateString('ar-EG')}
                </span>
              </Card>
            ))}
            {notes.length === 0 && (
              <div className="empty-state">
                <p>لا توجد ملاحظات</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Notes

